import { isPPDeprecated } from "@/constants/shared";
import { App } from "@/types";

export const APP_GRID_COLUMNS = [1, 2, 2, 2, 3];
export const NUM_TOP_APPS = 3;

export type FilterablePropertyName =
  | "New"
  | "Plume Points"
  | "PLUME Incentives"
  | "Level Up"
  | "External Points Program"
  | "External Campaigns";
export type FilterableProperty = {
  name: FilterablePropertyName;
  icon: string;
  filterFn: (app: App) => boolean;
};

const allFilterableProperties: FilterableProperty[] = [
  {
    name: "New",
    icon: "/assets/apps/modal/sparkles-circle.svg",
    filterFn: (app: App) => !!app.isNew,
  },
  {
    name: "Plume Points",
    icon: "/assets/pp-circle.svg",
    filterFn: (app: App) => !!app.doesCountForPoints,
  },
  {
    name: "PLUME Incentives",
    icon: "/assets/tokens/plume.svg",
    filterFn: (app: App) => !!app.hasOptimizerVault || !!app.hasRoycoMarket,
  },
  {
    name: "Level Up",
    icon: "/assets/quests/map.svg",
    filterFn: (app: App) => app.quests.length > 0,
  },
];

const PP_DEPRECATED_FILTER_NAMES: FilterablePropertyName[] = [
  "Plume Points",
  "Level Up",
];

export const filterableProperties: FilterableProperty[] = isPPDeprecated
  ? allFilterableProperties.filter(
      (p) => !PP_DEPRECATED_FILTER_NAMES.includes(p.name),
    )
  : allFilterableProperties;

export const filterablePropertiesForApps = (apps: App[]) =>
  filterableProperties.filter((p) => apps.some(p.filterFn));
